// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FI4g","clinicsSelect":"styles_clinicsSelect__PJAk_"};